import React from 'react';
import {observer} from 'mobx-react';
import Icon from '../common/Icon';
import GridCell from './GridCell';

const DownloadCell = ({slot, onClick = null, blockExpansion = false, forceDormant = false, modifiers={}}) => {
	let icon = '';
	const expanded = slot.isExpanded && !blockExpansion;
	if (slot.all) {
		icon = <Icon name={'plus'} width="10" height="10"/>;
	} else if (slot.isMulti) {
		icon = <Icon name={expanded? 'chevron-large-up': 'chevron-large-down'} width="17" height="10"/>;
	} else if (!slot.isEmpty || slot.all) {
		icon = slot.isActive ? <Icon name={'check'} width="17" height="13"/> :
			<Icon name={'download-available'} width="4" height="4"/>;
	}
	if (forceDormant) {
		icon = '';
	}
	return (
		<GridCell
			modifiers={Object.assign({
				fixed: true, // fixed width cell
				checker: true,
				expanded: expanded,
				hasMultiple: slot.isMulti,
				hasDownload: !slot.isEmpty || slot.all,
				all: slot.all,
				active: slot.isActive
			}, modifiers)}
			onClick={() => onClick(slot)}
		>
			{icon}
		</GridCell>
	);
};
export default observer(DownloadCell);

